import { NoOp } from 'utils/noop';
import { DeleteData, ListedViewsResp } from '../types';
import * as t from './actionTypes';
import {
  Action,
  BulkDeleteViewsRequestAction,
  FetchViewsRequestAction,
  FetchViewsResponseAction,
  MakeACopyRequestAction,
} from './types';

export const fetchViewsRequest = (queryParams: string): FetchViewsRequestAction => ({
  type: t.FETCH_VIEWS_REQUEST,
  queryParams,
});

export const fetchViewsResponse = (viewsResp: ListedViewsResp): FetchViewsResponseAction => ({
  type: t.FETCH_VIEWS_RESPONSE,
  views: viewsResp.records,
  metadata: viewsResp.metadata,
});

export const fetchViewsError = (): Action => ({
  type: t.FETCH_VIEWS_ERROR,
});

export const bulkDeleteViewsRequest = (
  deleteData: DeleteData[],
  email: string,
  callback: NoOp,
): BulkDeleteViewsRequestAction => ({
  type: t.BULK_DELETE_VIEWS_REQUEST,
  deleteData,
  email,
  callback,
});

export const makeACopyRequest = (
  viewId: number,
  isPrivate: boolean,
  callback: NoOp,
): MakeACopyRequestAction => ({
  type: t.MAKE_A_COPY_REQUEST,
  viewId,
  isPrivate,
  callback,
});
